// @noflow
// eslint-disable-next-line require-yield
function* noop({ payload }) {
    if (process.env.NODE_ENV !== 'production') {
        window.console.warn(
            'A saga recieved an unhandle error in its action payload. Did you mean to leave this unhandled? \n',
            payload
        );
    }
}

export default function handleSaga(fnSuccess, fnError = noop) {
    return function*(action) {
        yield* action.error ? fnError(action) : fnSuccess(action);
    };
}



// WEBPACK FOOTER //
// ./src/core/state/handle-saga.js